import React from "react";

export * from "./helpers";

// export { default as FormKunjunganRawatInap } from "./FormKunjunganRawatInap";
// export { default as FormAsuransi } from "./FormAsuransi";
// export { default as FormDataPasien } from "./FormDataPasien";
// export { default as FormFilterKunjunganRawatInap } from "./FormFilterKunjunganRawatInap";

export const FormFilterKunjunganRawatInap = React.lazy(() =>
  import("./FormFilterKunjunganRawatInap")
);

export const FormDataPasien = React.lazy(() => import("./FormDataPasien"));

export const FormAsuransi = React.lazy(() => import("./FormAsuransi"));

export const FormKunjunganRawatInap = React.lazy(() =>
  import("./FormKunjunganRawatInap")
);
